module.exports = __webpack_public_path__ + "static/media/integrations.a5c04986.svg";